module.exports = __webpack_public_path__ + "static/media/0.7c46a557.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/0.png
// module id = 510
// module chunks = 0